import angular from 'angular';
import constants from 'app/constants';
import directive from './top-threats.directive';


export default angular.module('app.components.advisory.bcp.topThreats', [
  constants,
])
  .directive('bcpTopThreats', directive)
  .controller('TopThreatsController', () => { /* here to provide controllerAs vm */ })
  .name;

console.log('app.components.advisory.bcp.topThreats created');
